export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const toAbsoluteUrl2 = (pathname: string) => '/' + process.env.PUBLIC_URL + pathname
